export const environment = {
  production: true,
  envName: 'production',
  title: 'Production Environment Heading',
  webURL: 'https://sistema.lubrikuv.com/',
  apiURL: 'https://sistema-back.lubrikuv.com/',
  kPagosURL: 'https://kpagos.kuvesoft.xyz/',
  habilitarSuscripciones: true,
  version: '7.2.0'
};
